export default {
    'Frühstück': 'mug-hot',
    'Halbpension': 'utensils',
    'Vollpension': 'utensils',
    'Tagung': 'user-chart',
    'Fahrrad': 'bicycle',
    'Fahrradhelm': 'hard-hat',
    'Helm': 'hard-hat',
    'Haustier': 'paw',
    'Hund': 'dog',
    'Pferd': 'horse',
    'Abwasser': 'water-lower',
    'Strom': 'plug',
    'Bettwäsche': 'bed-alt',
    'Aufbettung': 'bed-empty',
    'Zustellbett': 'bed-empty',
    'Babybett': 'baby',
    'Kinderbett': 'baby',
    'Boot': 'ship',
    'Schlauchboot': 'ship',
    'Handtuchset': 'blanket',
    'Brötchenservice': 'bread-loaf',
    'Hochstuhl': 'chair',
    'Kinderhochstuhl': 'chair',
    'Flasche': 'glass-cheers',
    'Obstkorb': 'apple-alt',
    'Blumenstrauß': 'flower-daffodil',
    'Sauna': 'heat',
    'Whirlwanne': 'hot-tub',
    'Whirlpool': 'hot-tub',
    'Wellness': 'spa',
    'Zelt': 'campground',
    'Motorrad': 'motorcycle',
    'Anhänger': 'trailer',
    'Endreinigung': 'vacuum',
    'PKW': 'car',
    'Auto': 'car',
    'Bus': 'bus',
    // 'Parkplatz': 'square-parking', // fa6
    'Parkplatz': 'parking', // fa5
    'Raum': 'kaaba',
    'Gruppenraum': 'kaaba',
    'Behälter': 'box',
    'Box': 'box',
    'Fass': 'box',
    'Paket': 'box',
    'Abholservice': 'shuttle-van',
    'Van': 'shuttle-van',
    'Shuttle': 'shuttle-van',
    'Schwimmwesten': 'swimmer',
    'Schwimmen': 'swimmer',
    'Baden': 'swimmer',
}